import { ROUTES } from '@/constants/routeConstants'
import { useOrganizationStore } from '@/store/organization'
import type { ReactNode } from '@tanstack/react-router'
import { Navigate } from '@tanstack/react-router'

export const RequireOrganization = ({ children }: { children: ReactNode }) => {
  const isLoading = useOrganizationStore((s) => s.isLoading)
  const organization = useOrganizationStore((s) => s.organization)

  // Wait for data to load before making any decisions
  if (isLoading) {
    return null
  }

  // Redirect to onboarding if organization doesn't exist or is pending approval
  const isOrganizationMissing = !organization
  const isPendingApproval = organization?.account_status === 'pending_approval'

  if (isOrganizationMissing || isPendingApproval) {
    return <Navigate to={ROUTES.ONBOARDING} replace={true} />
  }

  return children
}
